import { useEffect } from 'react';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

/**
 * Sprint 27, story-139 (OYScba1p). Keeps `document.documentElement.lang` in sync with the active
 * locale on every change, not just at load — `web/public/index.html:2` hardcodes `lang="en"` and
 * nothing updated it after initial paint before this story. Non-visual: renders nothing, called
 * once near the app root so login/register/the language switcher all benefit from the same
 * subscription without each needing to set it themselves.
 */
export function useSyncHtmlLang(): void {
  const activeLocale = useAppSelector((state: RootState) => state.locale.activeLocale);

  useEffect(() => {
    if (activeLocale) {
      document.documentElement.lang = activeLocale;
    }
  }, [activeLocale]);
}

export default useSyncHtmlLang;
